import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=2fd0fb8c&scoped=true"
import script from "./metadata.vue?vue&type=script&lang=js"
export * from "./metadata.vue?vue&type=script&lang=js"
import style0 from "./metadata.vue?vue&type=style&index=0&id=2fd0fb8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0fb8c",
  null
  
)

export default component.exports